import React, { useContext } from 'react'

/**
 * FormControlContext is for an input's props that it needs to share with its related components, like label or error text.
 *
 * If a prop can be different between different inputs, it can go in here.
 * If a prop is always the same for all inputs in a form, it should go in the FormProvider instead.
 */
export interface FormControlContextValue {
  nameContext: string
  idContext: string
  error?: string | React.ReactNode
  isDisabledContext?: boolean
  isInvalidContext?: boolean
  isRequiredContext?: boolean
}

const formControlContext = React.createContext<FormControlContextValue | undefined>(undefined)

export const FormControlProvider = formControlContext.Provider

export const useFormControlContext = (): Partial<FormControlContextValue> =>
  useContext(formControlContext) ?? ({} as Partial<FormControlContextValue>)
